// extracted by mini-css-extract-plugin
export default {"highlight":"ErrorPage_highlight__jEA+N"};